import { ButtonHTMLAttributes, FC } from 'react';

import { MoonLoader } from 'react-spinners';

import { Container, ButtonText } from './styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
};

const ButtonBlack: FC<ButtonProps> = ({ children, loading, ...rest }) => (
  <Container type="button" {...rest}>
    {loading ? (
      <MoonLoader size={30} color="#ffffff" />
    ) : (
      <ButtonText>{children}</ButtonText>
    )}
  </Container>
);

export default ButtonBlack;
